import { getHttpProtocol } from '@/shared-utilities';

const SURVEY_GRAPHQL_PATH = '/survey/graphql';

interface ResolveHttpUriArgs {
  apiHost: string;
  isServer: boolean;
  isProductionBuild: boolean;
  internalUrl: string | undefined;
}

export function resolveHttpUri({
  apiHost,
  isServer,
  isProductionBuild,
  internalUrl,
}: ResolveHttpUriArgs): string {
  const trimmedInternalUrl = internalUrl?.trim();
  if (isServer && isProductionBuild && trimmedInternalUrl) {
    return trimmedInternalUrl;
  }
  return `${getHttpProtocol()}://${apiHost}${SURVEY_GRAPHQL_PATH}`;
}
